import axios from "axios";
import Config from "./../../config/index";
import RefreshTokenHandler from "./refresh-token";
import { AnyAction } from "redux";



/**
 *
 * @param email
 * @param request_type
 * @param folio_no
 * @param request_status
 * @param page_number
 *
 */
const getInvestorRequestPagination = async (
    email: string,
    amc_code: string,
    request_type: string,
    folio_no: string,
    request_status: string,
    page_number: string,
) => {
    const url = `${Config.baseUrl}/investor-requests/paginate?email=${email}&amc_code=${amc_code}&request_type=${request_type}&folio_no=${folio_no}&request_status=${request_status}&page_number=${page_number}`;
    try {
        const result: any = await axios.get(url, {
            headers: {
                Authorization: sessionStorage.getItem("token") || "",
            },
        });
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await getInvestorRequestPagination(
                    email,
                    amc_code,
                    request_type,
                    folio_no,
                    request_status,
                    page_number
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

/**
 *
 * @param email
 * @param request_id
 * @param amc_code
 * @param fund_code
 * @param comment
 * @param related_txn_id
 *
 */
const AcceptInvestorRequestAfterTxn = async (
    email: string,
    request_id: string,
    amc_code: string,
    fund_code: string,
    comment: string,
    related_txn_id: string,
    conversion_out_txn_id: string = "",
    conversion_in_txn_id: string = "",
) => {
    const url = `${Config.baseUrl}/investor-requests/accept-investor-request`;
    try {
        const result: any = await axios.post(
            url,
            {
                email,
                request_id,
                amc_code,
                fund_code,
                comment,
                related_txn_id,
                conversion_out_txn_id,
                conversion_in_txn_id
            },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await AcceptInvestorRequestAfterTxn(
                    email,
                    request_id,
                    amc_code,
                    fund_code,
                    comment,
                    related_txn_id,
                    conversion_out_txn_id,
                    conversion_in_txn_id
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

/**
 *
 * @param email
 * @param request_id
 * @param amc_code
 * @param fund_code
 * @param comment
 *
 */
const AcceptInvestorRequestPayment = async (
    email: string,
    request_id: string,
    amc_code: string,
    fund_code: string,
    comment: string,
) => {
    const url = `${Config.baseUrl}/investor-requests/accept-investor-request-payment`;
    try {
        const result: any = await axios.post(
            url,
            {
                email,
                request_id,
                amc_code,
                fund_code,
                comment,
            },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await AcceptInvestorRequestPayment(
                    email,
                    request_id,
                    amc_code,
                    fund_code,
                    comment,
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

/**
 *
 * @param email
 * @param request_id
 * @param amc_code
 * @param fund_code
 * @param comment
 *
 */
const RejectInvestorRequest = async (
    email: string,
    request_id: string,
    amc_code: string,
    fund_code: string,
    comment: string,
) => {
    const url = `${Config.baseUrl}/investor-requests/reject-investor-request`;
    try {
        const result: any = await axios.post(
            url,
            {
                email,
                request_id,
                amc_code,
                fund_code,
                comment,
            },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await RejectInvestorRequest(
                    email,
                    request_id,
                    amc_code,
                    fund_code,
                    comment,
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

/**
 *
 * @param email
 * @param request_id
 * @param amc_code
 * @param fund_code
 * @param comment
 *
 */
const RejectInvestorRequestPayment = async (
    email: string,
    request_id: string,
    amc_code: string,
    fund_code: string,
    comment: string,
) => {
    const url = `${Config.baseUrl}/investor-requests/reject-investor-request-payment`;
    try {
        const result: any = await axios.post(
            url,
            {
                email,
                request_id,
                amc_code,
                fund_code,
                comment,
            },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await RejectInvestorRequestPayment(
                    email,
                    request_id,
                    amc_code,
                    fund_code,
                    comment,
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};

/**
 *
 * @param payment_proof
 * @param email
 * @param amc_code
 * @param fund_code
 * @param folio_no
 * @param request_id
 * @param bank_account_code
 * @param payment_method
 *
 */

const UpdatePaymentProof = async (
    admin: string = "true",
    payment_proof_file: string = "",
    email: string,
    amc_code: string,
    fund_code: string,
    folio_no: string,
    request_id: string,
    bank_account_code: string,
    payment_method: string,
) => {
    const url = `${Config.baseUrl}/investor-requests/update-payment-proof`;
    const formData = new FormData();
    const dataOBJ = {
        admin,
        payment_proof_file,
        email,
        amc_code,
        fund_code,
        folio_no,
        request_id,
        bank_account_code,
        payment_method,
    };
    let keys = Object.keys(dataOBJ);
    for (let i = 0; i < keys.length; i++) {
        let temp = keys[i];
        formData.append(temp, dataOBJ[temp]);
    }
    try {
        const result: any = await axios.post(url, formData, {
            headers: {
                Authorization: sessionStorage.getItem("token") || "",
            },
        });
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await UpdatePaymentProof(
                    admin,
                    payment_proof_file,
                    email,
                    amc_code,
                    fund_code,
                    folio_no,
                    request_id,
                    bank_account_code,
                    payment_method,
                );
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};


/**
 *
 * @param email
 * @param request_id
 * @param amc_code
 * @param fund_code
 * @param status
 */
const UpdateStatusInvestorRequest = async (
    email: string,
    request_id: string,
    amc_code: string,
    fund_code: string,
    status: string
) => {
    const url = `${Config.baseUrl}/investor-requests/status`;
    try {
        let result: any = await axios.post(
            url,
            { email, request_id, amc_code, fund_code, status },
            {
                headers: {
                    Authorization: sessionStorage.getItem("token") || "",
                },
            }
        );
        return result;
    } catch (err: any) {
        if (err.response.data.status == 401) {
            let responseToHandle = err.response.data;
            let result = await RefreshTokenHandler.handleIt(responseToHandle);
            if (result.status) {
                return await UpdateStatusInvestorRequest(email, request_id, amc_code, fund_code, status);
            } else {
                throw err;
                // return result
            }
        } else {
            throw err;
        }
    }
};


export {
    UpdatePaymentProof,
    RejectInvestorRequestPayment,
    RejectInvestorRequest,
    AcceptInvestorRequestPayment,
    AcceptInvestorRequestAfterTxn,
    getInvestorRequestPagination,
    UpdateStatusInvestorRequest
};
